import React from 'react';
import { useSelector } from 'react-redux';
import Marquee from 'react-fast-marquee';
import { Link } from 'react-router-dom';
import '../stylings/NewsMarquee.css';

export default function NewsMarquee() {
  const notices = useSelector((state) => state.notices.notices);

  const marqueeItems = notices.length > 0
    ? notices
    : [
        { _id: 'default1', title: 'Welcome to Akash Model Sr. Sec. School – Admissions Open for Session 2025-26' },
        { _id: 'default2', title: 'Annual Sports Day – Register Now | CBSE Affiliated School | Work Is Worship' },
      ];

  return (
    <div className="news-marquee-bar">
      <span className="marquee-label">
        <i className="fas fa-bullhorn me-1"></i> Latest News
      </span>
      <div className="marquee-content">
        <Marquee speed={50} gradient={false} pauseOnHover>
          {marqueeItems.map((item) => (
            <Link
              key={item._id}
              to={item._id.startsWith('default') ? '/noticeall' : `/notice/${item._id}`}
              className="marquee-item"
            >
              <i className="fas fa-circle marquee-dot"></i>
              {item.title}
            </Link>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
